import styled from "styled-components";

export const WordBankContainerSC = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SentenceSC = styled.div`
  padding: 12px;
  border-radius: 12px;
  background: #f1f1f1;
  max-width: fit-content;
`;

export const SentenceWrapperSC = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
`;
